import React from 'react';
import PropTypes from 'prop-types';

import { formatWaitTime } from '../../utils/poolQueue';

import {
  Container,
  Stat,
  StatLabel,
  StatValue,
} from './styles';
import texts from './texts.json';

const PoolQueueSummary = ({ poolQueueStats }) => {
  const {
    coachCount,
    openItemCount,
    unclaimedItemCount,
    oldestOpenAtSeconds,
    isOldestOpenPriority,
  } = poolQueueStats;

  return (
    <Container>
      <Stat>
        <StatLabel>{texts.coachesInPool}</StatLabel>
        <StatValue>{coachCount}</StatValue>
      </Stat>
      <Stat>
        <StatLabel>{texts.openItems}</StatLabel>
        <StatValue>{openItemCount}</StatValue>
      </Stat>
      <Stat>
        <StatLabel>{texts.unclaimedItems}</StatLabel>
        <StatValue>{unclaimedItemCount}</StatValue>
      </Stat>
      <Stat>
        <StatLabel>{texts.longestWait}</StatLabel>
        <StatValue $isPriority={isOldestOpenPriority}>
          {formatWaitTime(oldestOpenAtSeconds) ?? texts.noneOpen}
        </StatValue>
      </Stat>
    </Container>
  );
};

PoolQueueSummary.propTypes = {
  poolQueueStats: PropTypes.shape({
    coachCount: PropTypes.number.isRequired,
    openItemCount: PropTypes.number.isRequired,
    unclaimedItemCount: PropTypes.number.isRequired,
    oldestOpenAtSeconds: PropTypes.number,
    isOldestOpenPriority: PropTypes.bool,
  }).isRequired,
};

export default PoolQueueSummary;
